import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const StyledSpan = styled.span`
  color: skyblue;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: #1095F3;
  }
`;

const ToastWithLink = ({ empresa, navigate }) => {
  const { t } = useTranslation('cardapio');

  const handleClick = () => {
    let url = '/';

    // Construir URL priorizando slug (novo padrão /c/:slug)
    try {
      const sessionData = sessionStorage.getItem('sessionCompany');
      if (sessionData) {
        const parsed = JSON.parse(sessionData);
        if (parsed?.slug) {
          url = `/c/${parsed.slug}/info-loja`;
        } else if (parsed?.name && parsed?.id_empresa) {
          const nome = parsed.name.toLowerCase().replace(/\s+/g, '-');
          url = `/cardapio/${nome}/${parsed.id_empresa}/info-loja`;
        }
      }
    } catch (e) {
      console.error('[TOAST-LINK] Erro ao construir URL:', e);
    }

    // Preservar query params usando API nativa do browser (funciona fora do Router)
    const searchParams = new URLSearchParams(window.location.search);
    const params = new URLSearchParams();
    const externalId = searchParams.get('external_id');
    const mode = searchParams.get('mode');
    if (externalId) params.set('external_id', externalId);
    if (mode) params.set('mode', mode);
    const qs = params.toString();
    const finalUrl = qs ? `${url}?${qs}` : url;

    navigate(finalUrl, { state: { infoEmpresa: empresa } });
  };

  return (
    <div>
      {t('toast.storeClosedNow')}
      <StyledSpan onClick={handleClick}>
        {t('toast.clickHere')}
      </StyledSpan>{t('toast.toSeeHours')}
    </div>
  );
};

export default ToastWithLink;
